import $ from "jquery";
window.$ = window.jQuery = $;

import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "simplebar/dist/simplebar.js";
import "jquery-touchswipe/jquery.touchSwipe.js";

$(function () {
  $(".carousel .carousel-inner").swipe({
    swipeLeft: function (event, direction, distance, duration, fingerCount) {
      this.parent().carousel("next");
    },
    swipeRight: function () {
      this.parent().carousel("prev");
    },
    threshold: 0,
    tap: function (event, target) {
      window.location = $(this).find(".carousel-item.active a").attr("href");
    },
    excludedElements: "label, button, input, select, textarea, .noSwipe",
  });

  $(".carousel .carousel-inner").on("dragstart", "a", function () {
    return false;
  });
});
